<template>
    <div id="ttaddMsg">
        <div id="headers">
            <i class="arr" @click="goBack()" v-if="isMsk"></i>
            <p class="title">{{title}}</p>
        </div>
        <div class="setFix"></div>
        <form action="">
            <mt-field label="姓名" class="addTag" placeholder="请输入姓名" v-model="form.name"></mt-field>
            <mt-field label="手机号" class="addTag" placeholder="请输入手机号" type="tel" v-model="form.mobile" :disabled="!isMsk?true:false"></mt-field>
            <mt-field label="身份证号" class="addTag" placeholder="请输入身份证号" type="idcard" v-model="form.card"></mt-field>
            <div class="rowItem rowItem1 sfRow">
                <span class="name">身份<i class="red">*</i></span> 
                <mt-radio class="radios"
                v-model="form.owner"
                @change="chioceVal"
                disabled=""
                :options="options">
                </mt-radio>
            </div>
            <div class="rowItem" v-if="form.owner=='租户'"  @click="chioceTime">
                租期截止日期<i>*</i> <span style="float:none;">{{form.expire_time}}</span>
            </div>
            <mt-field label="公司名称" v-if="form.owner=='公司'" class="addTag" placeholder="请输入公司名称" type="text" v-model="form.company"></mt-field>
            <mt-field label="事由" v-if="form.owner=='访客'" class="addTag" placeholder="请输入事由" type="text" v-model="form.other"></mt-field>
            <!-- <div class="rowItem"  v-if="form.owner==''" @click="chioceBuild">
                楼号<i>*</i> <span>{{form.allowAddress}}</span>
            </div> -->
            <mt-field label="住址" class="addTag" placeholder="如东方花园小区6栋3单元202" type="text" v-model="form.address"></mt-field>
            <!-- 是否十四天内返京 -->
            <div class="rowItem rowItem1">
                <span class="name">是否十四天内返京<i class="red">*</i></span> 
                <mt-radio class="radios"
                v-model="isYes"
                @change="chioceVal2"
                disabled=""
                :options="options2">
                </mt-radio>
            </div>
            <div class="bacKShow" v-if="showbackBox">
                <div class="rowItem"  @click="chioceTime2">
                    返京日期<i>*</i> <span style="float:none;">{{form.return_date}}</span>
                </div>
                <mt-field label="从何地返京" class="addTag" placeholder="如湖北武汉" type="ornot" v-model="form.wuhan"></mt-field>
                <div class="rowItem" style="border-bottom:0;"  @click="test">
                    返程交通工具 <span style="float:none;">{{form.vehicle}}</span>
                </div>
                <mt-field label="备注" placeholder="请填写航班号或车次" type="remark" v-model="form.backup"></mt-field>
            </div>
        </form>
        <!-- 选择返京日期 -->
        <mt-datetime-picker
            ref="picker2"
            type="date"
            :startDate="startDateval2"
            :endDate="endDate2"
            v-model="pickerValue2"
            @confirm="getTimeval2">
        </mt-datetime-picker>
        <!-- 选择租赁截止日期 -->
        <mt-datetime-picker
            ref="picker"
            type="date"
            :startDate="startDateval"
            :endDate="endDateval"
            v-model="pickerValue"
            @confirm="getTimeval">
        </mt-datetime-picker>
        <!-- 选择楼号 -->
        <transition name="slide-fade">
            <div v-if="showBuild" class="chiceBox">
                <div class="innerBox">
                    <mt-picker :slots="buildslots" @change="onValuesChange2"></mt-picker>
                    <div class="btns">
                        <a href="javascript:;" @click="cancle2">取消</a>
                        <a href="javascript:;" class="sure" @click="sure2">确定</a>
                    </div>
                </div>
            </div>
        </transition>
        <!-- 选择交通工具 -->
        <transition name="slide-fade">
            <div v-if="showBtm" class="chiceBox">
                <div class="innerBox">
                    <mt-picker :slots="slots" @change="onValuesChange"></mt-picker>
                    <div class="btns">
                        <a href="javascript:;" @click="cancle">取消</a>
                        <a href="javascript:;" class="sure" @click="sure">确定</a>
                    </div>
                </div>
            </div>
        </transition>
        <div class="setH"></div>
        <mt-button type="danger" class="submitBtn" @click="submitForm">提交</mt-button>
    </div>
</template>
<script>
import axios from "axios";
import Top from "@/component/top/top";
import { MessageBox, Toast } from 'mint-ui';
import moment from 'moment'
export default {
    components:{
        Top
    },
    data() {
        return {
            isMsk:this.$route.query.glmsk,
            showbackBox:false,
            pickerValue2:'',
            startDateval:new Date(),
            startDateval2:moment().subtract(14, 'days').toDate(),
            endDateval:moment().add(3, 'years').toDate(),
            endDate2: new Date(),
            title:'',
            showBtm:false,
            showBuild:false,
            pmobile:'',
            pickerValue:'',
            allow:'',
            isYes:'',
            form:{
                other:'',
                return_date:'请选择',
                name:'',
                expire_time:'请选择',
                company:'',
                mobile:'',
                card:'',
                address:'',
                wuhan:'',
                backup:'',
                vehicle:'请选择',
                owner:'',
                allowAddress:'请选择'
            },
            options:[
                {
                    label: '业主',
                    value: '业主',
                },
                {
                    label: '租户',
                    value: '租户',
                },
                {
                    label: '公司',
                    value: '公司',
                },
                {
                    label: '访客',
                    value: '访客',
                }
            ],
            options2:[
                {
                    label: '否',
                    value: '否',
                },
                {
                    label: '是',
                    value: '是',
                },
            ],
            slots: [{values: ['请选择','大巴', '飞机', '自驾', '高铁']}],
            buildslots: '',
            isDisable:true
        }
    },
    created() {
    },
    mounted() {
        if(this.$route.query.glmsk) {
            this.title = '信息登记'
        }else{
            this.getInfo()
        }
    },
    methods:{
        test() {
            this.showBtm = true
        },
        chioceBuild() {
            this.showBuild = true
        },
        chioceTime() {
            this.$refs.picker.open();
        },
        chioceTime2() {
            this.$refs.picker2.open();
        },
        onValuesChange(index,value) {
            this.form.vehicle = value[0]
        },
        onValuesChange2(index,value) {
            this.form.allowAddress = value[0]
        },
        submitForm() {
            if(this.form.expire_time=='请选择'){
                this.form.expire_time = ''
            }
            if(this.form.vehicle=='请选择'){
                this.form.vehicle = ''
            }
            if(this.form.allowAddress=='请选择'){
                this.form.allowAddress = ''
            }
            if(!this.form.name) {
                Toast('请输入姓名');
            }else if(!this.form.mobile) {
                Toast('请输入手机号');
            }else if(!this.form.card) {
                Toast('请输入身份证号');
            }else if(!this.form.owner) {
                Toast('请选择身份');
            }else if(!this.form.address) {
                Toast('请输入地址');
            }else if(this.form.owner == '租户'&&!this.form.expire_time){
                Toast('请选择租赁截止日期');
            }else if(this.form.owner == '公司'&&!this.form.company){
                Toast('请输入公司名称');
            }else if(this.form.owner == '访客'&&!this.form.other){
                Toast('请输入事由');
            }else if(!this.isYes) {
                Toast('请选择十四天内是否返京');
            }else if(this.isYes=='是'&&!this.form.return_date){
                Toast('请选择返京时间');
            }else if(this.isYes=='是'&&!this.form.wuhan) {
                Toast('请输入从何地返京');
            }else{
                MessageBox({
                    title: '提示',
                    confirmButtonText:'确定提交',
                    message: '请确认信息填写无误后点击确认提交?',
                    showCancelButton: true,
                }).then(action => {
                    let params = {}
                    if(this.$route.query.glmsk) {
                        params = {
                            token:this.getuserToken(),
                            poiId:this.$route.query.poiId,
                            name:this.form.name,
                            mobile:this.form.mobile,
                            card:this.form.card.trim(),
                            address:this.form.address,
                            wuhan:this.form.wuhan,
                            backup:this.form.backup,
                            vehicle:this.form.vehicle,
                            owner:this.form.owner,
                            expire_time:this.form.expire_time,
                            No:this.form.allowAddress,
                            company:this.form.company,
                            return_date:this.form.return_date,
                            other:this.form.other,
                            import :1
                        }
                    }else{
                        params = {
                            token:this.getuserToken(),
                            poiId:this.$route.query.poiId,
                            name:this.form.name,
                            mobile:this.form.mobile,
                            card:this.form.card.trim(),
                            address:this.form.address,
                            wuhan:this.form.wuhan,
                            backup:this.form.backup,
                            vehicle:this.form.vehicle,
                            owner:this.form.owner,
                            expire_time:this.form.expire_time,
                            No:this.form.allowAddress,
                            company:this.form.company,
                            return_date:this.form.return_date,
                            other:this.form.other
                        }
                    }
                        
                    if (action == 'confirm') {
                        //确认的回调
                        axios.post(this.commonIp()+'/v1/userCard',params).then((res) => {
                            if(res.data.code == '200') {
                                axios.get(this.commonIp()+`/v1/userCard/my?token=${this.getuserToken()}&poiId=${this.$route.query.poiId}`)
                                    .then((res) => {
                                        if(res.data.code == '200') {
                                            if(this.$route.query.glmsk) {
                                                this.$router.push({path:`/records?poiId=${this.$route.query.poiId}`})
                                            }else{
                                                this.$router.push({path:`/pcheck?poiId=${this.$route.query.poiId}`})
                                            }
                                        }else{
                                            Toast(res.data.message)
                                        }
                                    })
                            }else{
                                Toast(res.data.message)
                            }
                        })
                    }
                }).catch(err => { 
                    if (err == 'cancel') {     //取消的回调
                    
                    } 
                });
            }
        },
        cancle() {
            this.showBtm = false
            this.form.vehicle = '请选择'
        },
        cancle2() {
            this.showBuild = false
            this.form.allowAddress = '请选择'
        },
        sure() {
            this.showBtm = false
        },
        sure2() {
            this.showBuild = false
        },
        goBack() {
            this.$router.go(-1)
        },
        getInfo() {
            axios.post(this.commonIp()+'/v1/userCard/userProfile',{
                token:this.getuserToken(),
                poiId:this.$route.query.poiId
                // token:"l2O22owRc2BDRbRZBUHL2B2HDir25UR5",
                // poiId:'B000AB9AGW'
            }).then((res) => {
                if(res.data.code == '200') {
                    this.buildslots = [{values: res.data.data.allowAddress}]
                    this.allow = res.data.data.allowAddress.length
                    if(res.data.data.community!=null) {
                        this.title = `${res.data.data.community.community}信息登记`
                    }else{
                        this.title = '信息登记'
                    }
                    if(res.data.data.userCard!=null) {
                        this.status = res.data.data.userCard.status
                        this.uptime = res.data.data.userCard.created_at
                        this.form = res.data.data.userCard
                    }else{
                        this.form.mobile = res.data.data.mobile
                    }
                }
            })
        },
        chioceVal(val) {
            if(val!='租户') {
                this.form.expire_time = ''
            }
            if(val !='公司') {
                this.form.company = ''
            }
            if(val !='访客') {
                this.form.other = ''
            }
            this.form.owner = val
        },
        chioceVal2(val){
            this.isYes = val
            if(val == '是') {
                this.showbackBox = true
            }else{
                this.showbackBox = false
                this.form.return_date = ''
                this.form.wuhan = ''
                this.form.vehicle = ''
                this.form.backup = ''
            }
        },
        getTimeval(val) {
            this.form.expire_time = moment(val.getTime()).format('YYYY-MM-DD')
        },
        getTimeval2(val) {
            this.form.return_date = moment(val.getTime()).format('YYYY-MM-DD')
        }
    }
}
</script>
<style lang="less">
    @import "~@/assets/less/index.less";
    .mint-msgbox-confirm{
        color:#23b355;
        border-left:1px solid #eee;
    }
    #ttaddMsg{
        .mint-cell-text{
            font-size:17px;
        }
        .mint-field-core{
            font-size:17px;
        }
        .setH{
            height: 100px;
        }
        .slide-enter-active,
        .slide-leave-active {
            transition: all 0.3s;
        }
        .slide-enter,
        .slide-leave-to {
            transform: translateY(100%);
        }
        .mint-datetime-action{
            color:#25cf8d;
        }
        input:disabled{
            color:#333;
        }
        .addTag{
            position: relative;
            .mint-cell-title::after{
                color:red;
                content:'*';
                display: inline-block;
                vertical-align: bottom;
            }
        }
        .rowItem{
            padding:0 16px;
            border-top:1px solid #eee;
            border-bottom:1px solid #eee;
            line-height: 48px;
            &.sfRow{
                padding-right:10px;
                &.mint-cell{
                    width:71px;
                }
                .mint-radio-label{
                    margin-left:0;
                }
                .mint-radio-label{
                    font-size:16px;
                }
            }
            &.rowItem1{
                border-bottom: 0 none;
            }
            i{
                color:red;
                font-style: normal;
            }
            .clearfix();
            span{
                .fr();
                font-size: 17px;
                color: #666;
            }
            .mint-cell-value input{
                font-size:17px;
            }
            .name{
                .fl();
                color:#000;
                font-size:17px;
            }
            .mint-cell-value input{
                font-size:15px;
            }
            .mint-radio-core{
                width: 18px;
                height: 18px;
                margin-left:2px;
            }
            .mint-radio-input:checked + .mint-radio-core{
                background:#25cf8d;
                border-color:#25cf8d;
                width:18px;
                height: 18px;
                &::after{
                    top:4px;
                    left:4px;
                }
            }
            .radios{
                .fr();
                .mint-cell-wrapper{
                    padding:0;
                    border-bottom:0;
                }
                .mint-cell{
                    .fl();
                    border-top:0;
                }
                .mint-radiolist-title{
                    display: none;
                }
            }
        }
        .setFix{
            border:0;
        }
        .chiceBox{
            width:100%;
            height: 100%;
            position: fixed;
            top:0;
            background:rgba(0,0,0,.5);
            z-index:99;
            .innerBox{
                padding:0 0 30px;
                background:#fff;
                position: absolute;
                bottom:0;
                width:100%;
                .btns{
                    margin-top:30px;
                    text-align: center;
                    a{
                        padding:8px 40px;
                        text-align: center;
                        display: inline-block;
                        background:#eee;
                        border-radius:5px;
                        color:#25cf8d;
                        &.sure{
                            margin-left:10px;
                            background:#25cf8d;
                            color:#fff;
                        }
                    }
                }
            }
        }
        .mint-msgbox-header{
            display: none !important;
        }
        .mint-cell{
            border-top:1px solid #eee;
            .mint-cell-value input{
                background:#fff;
            }
            .mint-cell-wrapper{
                background-image:none;
                padding:0 16px;
            }
            &:last-child{
                background-image:none;
                // border-bottom:1px solid #eee;
            }
            .mint-cell-value{
                font-size:@ft14;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/addmsg/addmsg.vue